import { fontSize, padding } from '@mui/system'
import React from 'react'
import './About.css'

const About = () => {
  return (
  <>
    <main className='abaut-container'>
      <section>
                    <h1 id="main-content-title" tabIndex="-1">שאלות נפוצות: </h1>
          פורטל TLV OpenData שם לעצמו למטרה לקדם שקיפות מידע לציבור, עידוד פיתוח כלים יצירתיים לפתרון בעיות עירוניות ויצירת דו שיח עם תושבי העיר.&#160
          <h2>
              <span className='ms-rteThemeForeColor-2-0'>מתי יתווספו מאגרים חדשים?</span></h2>
          <p>ניתן לצפות בכל קבצי הנתונים הקיימים כיום באתר. עם הזמן, נרחיב ונוסיף עוד מידע על הקיים וכן מערכי מידע חדשים.<br /></p>
          <h2>
              <span className='ms-rteThemeForeColor-2-0'>האם יפורסמו הנתונים הפרטיים שלנו?</span></h2>
          <p>תהליכים קפדניים נמצאים במקום כדי להגן על הפרטיות שלכם. לא נפרסם כל מידע בעל אופי אישי או רגיש.<br /></p>
          <h2>
              <span className='ms-rteThemeForeColor-2-0'>מה אפשר לעשות עם הנתונים?</span></h2>
          <p>ניתן לשתף את המידע ולעשות בו כל שימוש ובלבד שהוא עומד בתנאי בהתאם לרישיון השימוש של האתר.<br /></p>
          <h2>
              <span className='ms-rteThemeForeColor-2-0'>באיזו תדירות מעודכנים הנתונים?</span></h2>
          <p>תדירות העדכונים שונה עבור כל מערך נתונים. ניתן למצוא את תאריך העדכון בתוך המטא דאטה של כל מערך נתונים. בחרו בכרטיסייה &#39;מידע&#39; בעת הצגת מערך נתונים כדי למצוא את תאריך עדכון המידע האחרון.<br /></p>
          <span style={{fontSize: 24}}>
              <span className='ms-rteThemeForeColor-2-0'>כיצד ניתן לדווח על שגיאה במערך נתונים?</span><br /></span>אם זיהיתם שגיאה או חוסרים במערך הנתונים, תוכלו לבחור בכרטיסייה &#39;דיון&#39; ולפרסם תגובה, או לחילופין, ליצור עמנו קשר.&#160; &#160; &#160;
              </section>
             </main>
             </>

    
  )
}

export default About